import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoursedurationRoutingModule } from './courseduration-routing.module';
import { CoursedurationListComponent } from './courseduration-list/courseduration-list.component';
import { CoursedurationCreateComponent } from './courseduration-create/courseduration-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [CoursedurationListComponent, CoursedurationCreateComponent],
  imports: [
    CommonModule,
    CoursedurationRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class CoursedurationModule { }
